import DeliverySegment from './DeliverySegment';
import PickupSegment from './PickupSegment';

export default {
  DeliverySegment,
  PickupSegment,
};
